import { fetcher } from "helpers/fetcher";

import {
  TGetBUScorecardHistoryStaffReq,
  TGetBUScorecardHistoryStaffRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUScorecardHistoryStaff = async (
  payload: TGetBUScorecardHistoryStaffReq,
  language: string
) => {
  return await fetcher<
    TGetBUScorecardHistoryStaffRes,
    TGetBUScorecardHistoryStaffReq["data"]
  >(ENDPOINT.MANAGEMENT.GET_BU_SCORECARD_HISTORY_STAFF, {
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.MANAGEMENT.GET_BU_SCORECARD_HISTORY_STAFF.version,
      [API_HEADER.BU_ID]: payload.idBu,
      [API_HEADER.LANGUAGE]: language,
    },
    data: payload.data,
  });
};

export const queryGetBUScorecardHistoryStaff = async (
  payload: TGetBUScorecardHistoryStaffReq,
  language: string
) => {
  return (await getBUScorecardHistoryStaff(payload, language)).data;
};

queryGetBUScorecardHistoryStaff._key = (
  payload: TGetBUScorecardHistoryStaffReq,
  language: string
) => [
  ENDPOINT.MANAGEMENT.GET_BU_SCORECARD_HISTORY_STAFF.url,
  payload,
  language,
];
